<template>
  <div
    class="row items-start"
    :class="compactView ? 'q-col-gutter-sm' : 'q-col-gutter-md'"
  >
    <div class="text-bold col-12 q-pt-md">
      Header
    </div>
    <model-form-input
      field="config.bannerHeaderContent"
      value-type="String"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
      label="Header"
      :rules="[val => !!val || 'Field is required']"
    />
    <q-select
      v-model="globalWidget.config.bannerHeaderTextAlign"
      :class="compactView ? 'col-6 q-pb-xs' : 'col-2'"
      label="Text Align"
      :options="textAlignOptions"
      :disable="$_.isEmpty(globalWidget.config.bannerHeaderContent)"
      map-options
      emit-value
    />
    <q-select
      v-model="globalWidget.config.bannerHeaderLinkType"
      :class="compactView ? 'col-6 q-pb-xs' : 'col-2'"
      label="Link Type"
      :options="linkTypeOptions"
      :disable="$_.isEmpty(globalWidget.config.bannerHeaderContent)"
      clearable
      bottom-slots
      map-options
      emit-value
      @update:model-value="_value => globalWidget.config.bannerHeaderLinkableId = null"
    />
    <div
      v-if="$_.isEmpty(globalWidget.config.bannerHeaderContent) || $_.isNil(globalWidget.config.bannerHeaderLinkType)"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
    >
      <q-input
        label="Link"
        disable
      />
    </div>
    <div
      v-else
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
    >
      <q-input
        v-if="globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.URL"
        v-model="globalWidget.config.bannerHeaderLinkUrl"
        :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
        label="URL"
        :rules="[val => $_.startsWith(val, 'http') || 'Please enter a valid url']"
        bottom-slots
      />
      <q-select
        v-else
        v-model="globalWidget.bannerHeaderLinkableId"
        :display-value="bannerHeaderLinkableDisplayValue"
        :label="bannerHeaderLinkableLabel"
        stack-label
        :options="bannerHeaderLinkableOptions"
        option-label="name"
        option-value="id"
        map-options
        emit-value
        bottom-slots
        use-input
        input-style="search"
        debounce="100"
        :rules="[val => !$_.isNil(val) || 'Field is required']"
        @filter="filterLinkableOptions"
      />
    </div>
  </div>
  <div
    class="row items-start"
    :class="compactView ? 'q-col-gutter-sm q-mt-xs' : 'q-col-gutter-md'"
  >
    <div class="text-bold col-12 q-pt-md">
      Body
    </div>
    <model-form-input
      field="config.bannerBodyContent"
      value-type="String"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
      label="Body"
    />
    <q-select
      v-model="globalWidget.config.bannerBodyTextAlign"
      :class="compactView ? 'col-6 q-pb-xs' : 'col-2'"
      label="Text Align"
      :options="textAlignOptions"
      :disable="$_.isEmpty(globalWidget.config.bannerBodyContent)"
      map-options
      emit-value
    />
    <q-select
      v-model="globalWidget.config.bannerBodyLinkType"
      :class="compactView ? 'col-6 q-pb-xs' : 'col-2'"
      label="Link Type"
      :options="linkTypeOptions"
      :disable="$_.isEmpty(globalWidget.config.bannerBodyContent)"
      bottom-slots
      map-options
      emit-value
      @update:model-value="_value => globalWidget.config.bannerBodyLinkableId = null"
    />
    <div
      v-if="$_.isEmpty(globalWidget.config.bannerBodyContent) || $_.isNil(globalWidget.config.bannerBodyLinkType)"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
    >
      <q-input
        label="Link"
        disable
      />
    </div>
    <div
      v-else
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
    >
      <q-input
        v-if="globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.URL"
        v-model="globalWidget.config.bannerBodyLinkUrl"
        :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
        label="URL"
        :rules="[val => $_.startsWith(val, 'http') || 'Please enter a valid url']"
        bottom-slots
      />
      <q-select
        v-else
        v-model="globalWidget.bannerBodyLinkableId"
        :display-value="bannerBodyLinkableDisplayValue"
        :label="bannerBodyLinkableLabel"
        stack-label
        :options="bannerBodyLinkableOptions"
        option-label="name"
        option-value="id"
        map-options
        emit-value
        bottom-slots
        use-input
        input-style="search"
        debounce="100"
        :rules="[val => !$_.isNil(val) || 'Field is required']"
        @filter="filterLinkableOptions"
      />
    </div>
  </div>
  <div
    class="row items-start q-mb-md"
    :class="compactView ? 'q-col-gutter-sm q-mt-xs' : 'q-col-gutter-md'"
  >
    <q-toggle
      v-model="globalWidget.config.bannerIsSticky"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
      label="Sticky"
    >
      <q-tooltip>
        Stays visible at the top of the page when scrolling. Has no effect on preview below.
      </q-tooltip>
    </q-toggle>
    <div
      class="row q-col-gutter-md"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-4'"
    >
      <q-toggle
        v-model="globalWidget.config.bannerShowIcon"
        class="col"
        label="Show Icon"
      />
      <div
        class="col-auto"
        :style="{
          cursor: globalWidget.config.bannerShowIcon ? 'pointer' : 'not-allowed',
          opacity: globalWidget.config.bannerShowIcon ? 1 : 0.5
        }"
      >
        <q-icon
          :name="globalWidget.config.bannerIconName"
          style="font-size: 2rem"
          @click="() => globalWidget.config.bannerShowIcon && $refs.iconPickerDialog.show()"
        />
      </div>
    </div>
  </div>
  <icon-picker-dialog
    ref="iconPickerDialog"
    :model="globalWidget.config"
    icon-property="bannerIconName"
  />
</template>

<script>
import GlobalWidget, { LINK_TYPE_OPTIONS, RESTORATION_FREQUENCY_OPTIONS, TEXT_ALIGN_OPTIONS } from 'src/models/global-widget/GlobalWidget'
import IconPickerDialog from 'src/modules/admin/components/IconPickerDialog.vue'

export default {
  name: 'GlobalWidgetBannerEditor',
  components: {
    IconPickerDialog
  },
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    compactView: {
      type: Boolean,
      default: false
    }
  },
  models: {
    movies: {
      fields: ['id', 'name'],
      variables () {
        return {
          searchString: this.movieSearchString,
          orderBy: 'createdAt',
          descending: true,
          limit: 10
        }
      }
    },
    pages: {
      fields: ['id', 'slug', 'title'],
      variables () {
        return {
          searchString: this.pageSearchString,
          limit: 10
        }
      }
    }
  },
  data () {
    return {
      movieSearchString: '',
      pageSearchString: ''
    }
  },
  computed: {
    bannerHeaderLinkableDisplayValue () {
      if (!_.includes(_.keys(this.globalWidget.describeDirty), 'bannerHeaderLinkableId')) {
        return this.globalWidget.bannerHeaderLinkableName
      } else if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return _.find(this.movies.data, movie => movie.id === this.globalWidget.bannerHeaderLinkableId)?.name
      } else if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return _.find(this.pages.data, page => page.id === this.globalWidget.bannerHeaderLinkableId)?.title
      } else {
        return ''
      }
    },
    bannerHeaderLinkableLabel () {
      if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return 'Movie'
      } else if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return 'Page'
      } else {
        return 'URL'
      }
    },
    bannerHeaderLinkableOptions () {
      if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return this.movies.data
      } else if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return this.pages.data
      } else {
        return []
      }
    },
    bannerBodyLinkableDisplayValue () {
      if (!_.includes(_.keys(this.globalWidget.describeDirty), 'bannerBodyLinkableId')) {
        return this.globalWidget.bannerBodyLinkableName
      } else if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return _.find(this.movies.data, movie => movie.id === this.globalWidget.bannerBodyLinkableId)?.name
      } else if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return _.find(this.pages.data, page => page.id === this.globalWidget.bannerBodyLinkableId)?.title
      } else {
        return ''
      }
    },
    bannerBodyLinkableLabel () {
      if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return 'Movie'
      } else if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return 'Page'
      } else {
        return 'URL'
      }
    },
    bannerBodyLinkableOptions () {
      if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.MOVIE) {
        return this.movies.data
      } else if (this.globalWidget.config.bannerBodyLinkType === LINK_TYPE_OPTIONS.PAGE) {
        return this.pages.data
      } else {
        return []
      }
    }
  },
  created () {
    _.extend(this, {
      LINK_TYPE_OPTIONS,
      textAlignOptions: this.$mh.asOptions(TEXT_ALIGN_OPTIONS.ALL),
      linkTypeOptions: this.$mh.asOptions(LINK_TYPE_OPTIONS.ALL),
      restorationFrequencyOptions: this.$mh.asOptions(RESTORATION_FREQUENCY_OPTIONS)
    })
  },
  mounted () {
    this.$mh.setCustomPageStyles(this.globalWidget.transformedStyles)
  },
  unmounted () {
    this.$mh.setCustomPageStyles(null)
  },
  methods: {

    filterLinkableOptions (val, update, abort) {
      update(() => {
        this.headerLinkableSearchString = val.toLowerCase()
        if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.MOVIE) {
          this.movieSearchString = val.toLowerCase()
        } else if (this.globalWidget.config.bannerHeaderLinkType === LINK_TYPE_OPTIONS.PAGE) {
          this.pageSearchString = val.toLowerCase()
        }
      })
    }
  }
}
</script>
